export const fallbackPages = {
  "home": [
    {
      "key": "hero",
      "type": "hero",
      "content": {
        "title": "Move your World - MoveLand!",
        "button_target": "none"
      }
    },
    {
      "key": "welcome",
      "type": "text",
      "content": {
        "heading": "Willkommen bei MOVELAND",
        "body": "Wo der Rhythmus der Country-Musik auf den Spirit des Westens trifft. Hier erlebst du Freiheit, Gemeinschaft und pure Lebensfreude!"
      }
    },
    {
      "key": "upcoming_events",
      "type": "upcoming_events",
      "content": {
        "heading": "Als Nächstes bei Moveland"
      }
    },
    {
      "key": "expectations",
      "type": "text",
      "content": {
        "heading": "Was dich bei uns erwartet:"
      }
    },
    {
      "key": "line_dance",
      "type": "service_block",
      "content": {
        "heading": "Line Dance",
        "subtitle": "Darum tanzt du bei uns",
        "body": "Hier tanzt du nicht nur Schritte, sondern fühlst vom ersten Moment an den Takt, die Energie und die Gemeinschaft.",
        "bullets": [
          {
            "lead": "Einfach einsteigen",
            "text": "Ob ganz neu oder mit Erfahrung: Du findest schnell deinen Platz und dein Tempo."
          },
          {
            "lead": "Starke Community",
            "text": "Offene Gruppen, gute Stimmung und echtes Miteinander machen jede Stunde besonders."
          },
          {
            "lead": "Western-Flair live",
            "text": "Musik, Bewegung und Atmosphäre bringen genau das Gefühl, das man bei MoveLand sucht."
          }
        ],
        "button_label": "Mehr über Line Dance",
        "button_target": "services"
      }
    },
    {
      "key": "offers",
      "type": "card_list",
      "content": {
        "heading": "Weitere Angebote",
        "cards": [
          {
            "slot": "western",
            "title": "Westernreiten",
            "body": "Ergänzendes Angebot für Reitinteressierte."
          },
          {
            "slot": "farm",
            "title": "Landwirtschaft hautnah",
            "body": "Natur erleben und verstehen."
          }
        ]
      }
    }
  ],
  "about": [
    {
      "key": "hero",
      "type": "hero",
      "content": {
        "title": "Über mich",
        "button_target": "none"
      }
    },
    {
      "key": "intro",
      "type": "text",
      "content": {
        "heading": "Rahel Schmid",
        "subtitle": "Leiterin von Moveand",
        "body": "Ich bin Rahel Schmid und meine Leidenschaft gehört dem Line Dance. Mit viel Freude, Musik und Gemeinschaft möchte ich Menschen jeden Alters fürs Tanzen begeistern und gemeinsam unvergessliche Momente erleben."
      }
    },
    {
      "key": "story",
      "type": "text",
      "content": {
        "heading": "Über mich",
        "body": "Bevor ich meine Leidenschaft für den Tanz weitergegeben habe, habe ich einen etwas anderen Weg eingeschlagen: Ich bin gelernte Landwirtin EFZ, arbeite als diplomierte Hundetrainerin und habe mich mit viel Herzblut im Pferdebereich ausgebildet.\n\nWas das alles mit Tanzen zu tun hat? Mehr als man denkt. Es geht immer um Gefühl, Timing, Körpersprache – und darum, sich selbst und andere besser wahrzunehmen.\n\nMeine Tanzreise hat mich über viele Jahre geführt – vom Line Dance, auch in einer Showgruppe, bis hin zu Standardtänzen, Discofox und Jive. Meine Leidenschaft ist aber defintiv das Line dance, weil man da ohne Parter tanzen kann und immer neue Leute trifft. Tanzen war für mich immer ein Ort, an dem ich abschalten, auftanken und einfach ich selbst sein konnte.\n\nGenau das möchte ich auch in meinen Kursen weitergeben. Bei mir geht es nicht um Perfektion, sondern um Freude an der Bewegung, gemeinsames Erleben und darum, sich einfach wohlzufühlen – egal ob du ganz neu startest oder schon Erfahrung hast. Wenn du Lust hast, etwas Neues auszuprobieren, den Kopf freizubekommen und dabei noch nette Menschen kennenzulernen, dann bist du bei mir genau richtig."
      }
    },
    {
      "key": "passions",
      "type": "card_list",
      "content": {
        "heading": "Meine Leidenschaft",
        "intro": "Seit meiner Kindheit haben mich Pferde, Tanz und die Verbindung zur Natur fasziniert. Diese Leidenschaften haben mich dazu gebracht, MoveLand zu gründen - einen Ort, an dem Menschen ihre eigene Verbindung zu diesen wunderbaren Aktivitäten entdecken können.",
        "cards": [
          {
            "slot": "featured",
            "title": "Line Dance",
            "body": "Tanzen ist für mich Ausdruck von Lebensfreude und Gemeinschaft. Beim Line Dance erlebe ich immer wieder, wie Menschen zusammenkommen, sich bewegen und dabei pure Freude empfinden. Genau diese Energie möchte ich in jeder Stunde weitergeben."
          },
          {
            "slot": "secondary_1",
            "title": "Westernreiten",
            "body": "Die Harmonie zwischen Pferd und Mensch ist für mich das Schönste. Ich teile meine jahrelange Erfahrung im Westernreiten und Horsemanship, um anderen zu helfen, eine tiefe Verbindung zu ihren Pferden aufzubauen."
          },
          {
            "slot": "secondary_2",
            "title": "Hundetraining",
            "body": "Die Arbeit mit Hunden lehrt mich täglich Geduld, Verständnis und die Bedeutung von Vertrauen. Ich helfe Menschen dabei, eine starke Bindung zu ihren vierbeinigen Freunden aufzubauen."
          }
        ]
      }
    },
    {
      "key": "vision",
      "type": "card_list",
      "content": {
        "heading": "Meine Vision",
        "intro": "MoveLand ist mehr als nur ein Ort für Aktivitäten - es ist eine Gemeinschaft. Hier können Menschen ihre Leidenschaften entdecken, neue Fähigkeiten entwickeln und dabei Teil einer warmherzigen, unterstützenden Gemeinschaft werden. Mein Ziel ist es, jedem die Möglichkeit zu geben, seine eigene Verbindung zur Natur, zu Tieren und zur Bewegung zu finden.",
        "cards": [
          {
            "slot": "community",
            "title": "Gemeinschaft",
            "body": "Wir schaffen einen Raum, in dem sich jeder willkommen und zugehörig fühlt."
          },
          {
            "slot": "passion",
            "title": "Leidenschaft",
            "body": "Wir teilen unsere Begeisterung und helfen anderen, ihre eigenen Leidenschaften zu entdecken."
          },
          {
            "slot": "respect",
            "title": "Respekt",
            "body": "Wir behandeln Tiere, Natur und Menschen mit dem höchsten Respekt und Wertschätzung."
          }
        ]
      }
    },
    {
      "key": "contact_cta",
      "type": "contact_info",
      "content": {
        "heading": "Kontakt",
        "intro": "Ich freue mich darauf, Sie kennenzulernen und gemeinsam Ihre Reise bei MoveLand zu beginnen.",
        "box_heading": "Lass uns in Kontakt treten",
        "email": "moveland.swiss@gmail.com",
        "phone": "076/565 94 48",
        "button_label": "Kontaktformular",
        "button_target": "contact"
      }
    }
  ],
  "services": [
    {
      "key": "hero",
      "type": "hero",
      "content": {
        "title": "Unsere Angebote",
        "button_target": "none"
      }
    },
    {
      "key": "line_dance_intro",
      "type": "service_block",
      "content": {
        "heading": "Line Dance",
        "subtitle": "Darum tanzt du bei uns",
        "body": "Bei mir bekommst du nicht nur Schritte gezeigt, sondern ein klares, ruhiges und motivierendes Training, das dich wirklich weiterbringt. Ich erkläre Choreografien so, dass du sie sicher verstehen und mit Freude tanzen kannst. Du trainierst in einer Gruppe mit guter Stimmung, ohne Druck und mit echtem Fokus auf deinen Fortschritt.\n\nMein Ziel ist, dass du dich von Stunde zu Stunde sicherer fühlst, musikalischer wirst und mit einem richtig guten Gefühl nach Hause gehst. Egal ob du neu startest oder schon Erfahrung hast: du bekommst Struktur, persönliche Unterstützung und eine Atmosphäre, in der Lernen Spass macht.",
        "bullets": [
          {
            "lead": "Persönliche Begleitung",
            "text": "Klare Erklärungen, saubere Technik und Fortschritt in deinem Tempo."
          },
          {
            "lead": "Motivierende Gruppe",
            "text": "Ein wertschatzendes Miteinander, das dich dranbleiben lässt."
          }
        ]
      }
    },
    {
      "key": "line_dance_facts",
      "type": "fact_box",
      "content": {
        "heading": "Kursinfos auf einen Blick",
        "facts": [
          {
            "slot": "where",
            "label": "Wo?",
            "value": "Niederwil"
          },
          {
            "slot": "when",
            "label": "Wann?",
            "value": "Dienstagabend um 19:00 Uhr"
          },
          {
            "slot": "duration",
            "label": "Kursdauer",
            "value": " 8 Lektionen pro Kurs"
          },
          {
            "slot": "price",
            "label": "Preis",
            "value": "150.- CHF für 8 Lektionen"
          }
        ],
        "note": "Den nächsten Kursstart findest du im Events-Bereich.",
        "button_label": "Nächster Kursstart in Events",
        "button_target": "events"
      }
    },
    {
      "key": "line_dance_levels",
      "type": "card_list",
      "content": {
        "cards": [
          {
            "slot": "beginner",
            "title": "Beginner",
            "body": "Grundschritte und einfache Kombinationen. Perfekt für den Einstieg in die Welt des Line Dance. Wir nehmen uns Zeit, damit jeder Schritt sitzt."
          },
          {
            "slot": "improver",
            "title": "Improver",
            "body": "Komplexere Choreografien, verschiedene Tanzstile und mehr Variationen. Erweitere dein Repertoire und verbessere deine Technik."
          },
          {
            "slot": "intermediate",
            "title": "Intermediate",
            "body": "Anspruchsvolle Routinen, Performance-Training und Auftrittsvorbereitung. Für alle, die ihre Fähigkeiten auf die nächste Stufe bringen möchten."
          }
        ]
      }
    },
    {
      "key": "line_dance_room",
      "type": "text",
      "content": {
        "heading": "Unser Raum in Niederwil",
        "body": "Der Kursraum bietet Platz, klare Sicht und eine angenehme Atmosphäre für konzentriertes Lernen und gemeinsames Tanzen."
      }
    },
    {
      "key": "western",
      "type": "service_block",
      "content": {
        "heading": "Westernreiten/Horsemanship",
        "subtitle": "Vertrauen, Respekt und klare Kommunikation",
        "body": "Hier steht die feine Zusammenarbeit zwischen Mensch und Pferd im Mittelpunkt. Wir arbeiten an Grundlagen, Körpergefühl, Timing und einer ruhigen, verständlichen Hilfengebung.\n\nDer Fokus liegt auf einer sicheren, fairen und alltagstauglichen Beziehung zum Pferd, ob am Boden oder im Sattel.",
        "bullets": [
          {
            "lead": "Horsemanship",
            "text": "Bodenarbeit, Vertrauen und klare Signale für eine stabile Basis."
          },
          {
            "lead": "Western-Basics",
            "text": "Sitz, Balance und feine Hilfen mit Ruhe und Struktur."
          },
          {
            "lead": "Individuelle Begleitung",
            "text": "Inhalte werden auf Pferd und Mensch abgestimmt."
          }
        ]
      }
    },
    {
      "key": "farm",
      "type": "service_block",
      "content": {
        "heading": "Landwirtschaft hautnah",
        "subtitle": "Erleben statt nur zuschauen",
        "body": "Direkte Einblicke in den Alltag auf dem Hof mit Tieren, Natur und echten Aufgaben aus der Landwirtschaft.\n\nDas Angebot verbindet Wissen, praktische Erfahrung und Freude am Draussen-Sein für Kinder, Jugendliche und Erwachsene.",
        "bullets": [
          {
            "lead": "Praxisnah",
            "text": "Landwirtschaft mit echten Tätigkeiten und klaren Einblicken."
          },
          {
            "lead": "Tiernah",
            "text": "Verantwortungsbewusster Umgang mit Tieren und Natur."
          },
          {
            "lead": "Individuell",
            "text": "Inhalte nach Alter, Interesse und Gruppe planbar."
          }
        ]
      }
    },
    {
      "key": "cta",
      "type": "cta",
      "content": {
        "heading": "Interessiert?",
        "body": "Kontaktiere uns für weitere Informationen oder eine Schnupperstunde.",
        "email": "moveland.swiss@gmail.com",
        "phone": "076/565 94 48",
        "button_label": "Kontaktformular",
        "button_target": "contact"
      }
    }
  ],
  "contact": [
    {
      "key": "hero",
      "type": "hero",
      "content": {
        "title": "Kontakt",
        "subtitle": "Schreib uns, wir freuen uns auf dich",
        "button_target": "none"
      }
    },
    {
      "key": "details",
      "type": "contact_info",
      "content": {
        "heading": "Kontaktinformationen",
        "intro": "Wir freuen uns auf Ihre Nachricht!",
        "email": "moveland.swiss@gmail.com",
        "phone": "076/565 94 48"
      }
    }
  ]
}
